var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatMap10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 124,
    viewBox: "0 0 108 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_1693_53287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.3108 72.9847C91.0953 62.4165 84.9085 52.9527 81.592 49.5418C85.4026 36.3863 80.2733 25.3417 77.2323 21.4638C65.2227 12.1168 68.0086 8.06343 45.813 8.43158C25.9383 13.8126 16.8604 55.674 13.7825 84.7254C19.3831 100.71 29.0773 106.834 35.7634 110.008C51.977 117.84 61.2488 114.901 65.557 112.041C77.9596 106.471 83.1387 96.2732 83.1283 89.6618C87.5077 85.5946 89.0747 76.849 89.3108 72.9847Z",
    fill: "#499FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0107 71.6644C85.5509 62.318 79.9248 53.9 76.9192 50.8592C80.2666 39.2344 75.5823 29.4232 72.8218 25.9707C66.0057 15.6038 52.7629 11.359 46.9935 10.5324C28.507 5.68951 13.7607 53.561 16.117 81.5915C16.6705 96.4717 28.8816 105.896 34.918 108.748C49.5569 115.783 60.9349 112.529 64.794 110.023C75.9203 105.169 78.6011 92.2468 78.5507 86.3927C82.4664 82.8186 83.8222 75.0846 84.0107 71.6644Z",
    fill: "#30CB87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3964 46.5322C65.5841 44.2957 64.1091 41.4794 63.4732 40.3508C63.2549 38.5418 60.9136 35.8019 59.7703 34.6581C52.6019 29.4325 46.6172 28.6301 43.8366 28.7513C36.3062 27.4803 27.0623 47.7618 32.4548 59.4538L31.4377 65.1951L31.6459 70.6291C26.7645 82.5054 34.5791 89.6974 38.2529 92.701C49.2365 99.2778 55.7705 97.1803 59.9061 94.2494C69.4631 86.7331 68.8824 78.8748 67.2873 74.3378L66.544 70.3471L66.6545 62.4392L65.9101 54.3007L66.3964 46.5322Z",
    fill: "#FFC909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9659 66.1625C61.9424 61.9384 58.9105 57.8601 57.3975 56.349C61.6317 52.9431 61.6154 46.9133 61.078 44.3241C60.3737 36.5305 50.7253 33.2589 45.9892 32.5973C36.8411 32.1085 33.3283 42.1281 32.7154 47.199L33.5134 50.1727L33.9035 53.0816L35.0243 58.68L35.6848 60.3934L36.3865 65.4909C34.0877 69.2688 35.8951 75.1275 37.0862 77.5847C36.2292 83.6247 38.7541 87.5323 40.1238 88.7311C45.9505 95.3831 53.3948 92.7007 56.3885 90.528C62.5088 86.5082 62.6977 80.1111 62.0272 77.415C63.9013 71.6138 62.7672 67.4962 61.9659 66.1625Z",
    fill: "#FF2F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1693_53287",
    x: 9.78253,
    y: 4.4082,
    width: 83.8451,
    height: 114.633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1693_53287"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatMap10);
export default __webpack_public_path__ + "static/media/heatMap10.6684ca2d91b45cc28c672cba9e004e0d.svg";
export { ForwardRef as ReactComponent };